import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { HqNotificationKind } from "../api/shop.ts";
import { HqNotificationsPage } from "../components/shop/hq-notifications-page.tsx";

interface Search {
  readonly typ?: HqNotificationKind;
  readonly olasta?: boolean;
}

export const Route = createFileRoute("/bestallningar/historik")({
  component: Screen,
  validateSearch: (search: Record<string, unknown>): Search => ({
    ...(search.typ === "shop_order_placed" || search.typ === "shop_order_cancelled"
      ? { typ: search.typ }
      : {}),
    ...(search.olasta === true || search.olasta === "true" ? { olasta: true } : {}),
  }),
});

function Screen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <HqNotificationsPage
      filter={{ kind: search.typ ?? null, unreadOnly: search.olasta ?? false }}
      onFilterChange={(next) =>
        void navigate({
          search: {
            ...(next.kind === null ? {} : { typ: next.kind }),
            ...(next.unreadOnly ? { olasta: true } : {}),
          },
          replace: true,
        })
      }
    />
  );
}
